import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneairportcabs() {



const cardData = {
  keyword: " Pune Airport Cabs ",

"headingDescription": "Pune Airport Cabs provide quick, dependable, and comfortable transportation for travelers arriving at or departing from Pune Airport. Whether you need an early morning drop, a late-night pickup, or a smooth city transfer, SRS Cab Service ensures punctual service with professional drivers and clean vehicles. Designed for convenience, our airport cab solutions include instant booking, real-time tracking, and flexible ride options for individuals, families, and corporate travelers. With clear pricing and round-the-clock support, Pune Airport Cabs make every airport journey efficient and worry-free.",
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic fort and a symbol of Pune’s rich Maratha heritage. Travelers using Pune Airport Cabs often visit this landmark to explore its grand architecture and cultural significance."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is an important monument linked to India’s freedom struggle. Visitors using Pune Airport Cabs can explore its beautiful gardens and museum after arriving in the city."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a popular hill fort known for its scenic views and trekking opportunities. Travelers using Pune Airport Cabs often plan a visit here for nature and history."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is one of Pune’s most famous religious sites. Devotees using Pune Airport Cabs frequently visit this temple to seek blessings."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva. Visitors using Pune Airport Cabs enjoy its peaceful atmosphere in the city center."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum features a vast collection of traditional Indian artifacts. Travelers using Pune Airport Cabs explore this museum to experience local culture and history."
  },
  {
    "title": "Parvati Hill Temple",
    "description": "Parvati Hill Temple offers scenic views along with historic temples. Visitors using Pune Airport Cabs often climb the hill for sightseeing and spiritual experience."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a peaceful getaway known for its scenic surroundings. Travelers using Pune Airport Cabs visit this spot to relax and enjoy nature."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Pune Okayama Friendship Garden is a beautifully maintained Japanese-style garden. Visitors using Pune Airport Cabs enjoy walking through its calm and green environment."
  },
  {
    "title": "Lal Mahal",
    "description": "Lal Mahal is a historic site associated with Chhatrapati Shivaji Maharaj. Travelers using Pune Airport Cabs visit this place to explore Pune’s historical roots."
  }
],



services: [
{
name: "Pune Airport Cabs",
description: "Pune airport cabs provide reliable transportation for airport transfers and city travel. Customers can book cabs for pickups and drop-offs easily. Professional drivers ensure timely arrivals. Comfortable vehicles enhance travel experience. Flexible booking options are available. Travel conveniently with Pune airport cab services."
},
{
name: "Mumbai Airport to Pune Cab",
description: "Mumbai airport to Pune cab offers direct travel for passengers arriving in Mumbai. Customers can book cabs for smooth long-distance journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily from Mumbai Airport to Pune."
},
{
name: "Pune Airport Cab Services",
description: "Pune airport cab services provide dependable travel for airport transfers. Customers can book cabs for domestic and international flights. Professional drivers ensure timely pickups. Comfortable vehicles enhance travel comfort. Flexible booking options are available. Choose Pune airport cab services for hassle-free travel."
},
{
name: "Pune Airport Taxi Booking",
description: "Pune airport taxi booking offers quick and easy reservation options. Customers can book taxis online or via mobile apps. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your Pune airport taxi easily."
},
{
name: "Pune Airport Car Rental",
description: "Pune airport car rental provides flexible vehicle options for travelers. Customers can rent cars for local and outstation travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Transparent pricing ensures affordability. Rent cars easily from Pune Airport."
},
{
name: "Pune Airport Taxi Rate",
description: "Pune airport taxi rate offers clear pricing for airport travel. Customers can check fare details before booking rides. Affordable rates ensure budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose taxi services with transparent rates."
},
{
name: "Pune Airport Cab Charges",
description: "Pune airport cab charges provide detailed pricing for airport transfers. Customers can check charges before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with clear charges."
},
{
name: "Pune Airport Taxi Booking Online",
description: "Pune airport taxi booking online offers instant reservation options. Customers can book taxis digitally with ease. Professional drivers ensure timely pickups. Comfortable vehicles enhance travel comfort. Flexible booking options are available. Book your airport taxi online from Pune."
},
{
name: "Pune Airport Cab Pricing",
description: "Pune airport cab pricing provides transparent fare details for travelers. Customers can compare pricing before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with clear pricing."
},
{
name: "Pune Airport Car Hire with Driver",
description: "Pune airport car hire with driver offers comfortable travel with professional chauffeurs. Customers can enjoy stress-free journeys. Well-maintained vehicles ensure smooth rides. Ideal for business and family travel. Flexible booking options are available. Travel easily with driver-based car hire services."
},
{
name: "Pune to Shirdi Cab One Way",
description: "Pune to Shirdi cab one way offers economical travel without return charges. Customers can book direct rides easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Choose one-way cab services from Pune to Shirdi."
},
{
name: "Pune to Mumbai Airport Cab Fare",
description: "Pune to Mumbai airport cab fare provides pricing details for airport transfers. Customers can check fares before booking rides. Affordable rates ensure budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily to Mumbai Airport from Pune."
},
{
name: "Pune to Mumbai Airport",
description: "Pune to Mumbai airport service offers reliable travel for flight transfers. Customers can book cabs for timely arrivals. Professional drivers ensure smooth journeys. Comfortable vehicles enhance travel experience. Flexible booking options are available. Travel easily from Pune to Mumbai Airport."
},
{
name: "Pune Mumbai Airport Drop",
description: "Pune Mumbai airport drop provides direct one-way transportation services. Customers can book cabs for convenient airport drops. Professional drivers ensure timely journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Choose airport drop services from Pune."
},
{
name: "Pune Airport to Shirdi Cab",
description: "Pune airport to Shirdi cab offers direct travel from airport to pilgrimage destination. Customers can book cabs for immediate pickup. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel comfort. Flexible booking options are available. Travel easily from Pune Airport to Shirdi."
},
{
name: "One Way Cab Mumbai to Pune",
description: "One way cab Mumbai to Pune offers economical travel for single-direction journeys. Customers can book direct rides easily. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Choose one-way cab services from Mumbai to Pune."
},
{
name: "Pune Mumbai Cab Service",
description: "Pune Mumbai cab service provides reliable intercity transportation between two major cities. Customers can book cabs for business and leisure trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Flexible booking options are available. Travel easily with Pune Mumbai cab services."
}
],

tableData: [
["Pune Airport Cabs","Mumbai Airport to Pune Cab"],
["Pune Airport Cab Services","Pune Airport Taxi Booking"],
["Pune Airport Car Rental","Pune Airport Taxi Rate"],
["Pune Airport Cab Charges","Pune Airport Taxi Booking Online"],
["Pune Airport Cab Pricing","Pune Airport Car Hire with Driver"],
["Pune to Shirdi Cab One Way","Pune to Mumbai Airport Cab Fare"],
["Pune to Mumbai Airport","Pune Mumbai Airport Drop"],
["Pune Airport to Shirdi Cab","One Way Cab Mumbai to Pune"],
["Pune Mumbai Cab Service","Pune Airport Cabs"]
],



whychoose: [
  {
    WhyChooseheading: "On-Time Airport Pickup & Drop",
    WhyChoosedescription: "SRS Cab Service ensures punctual Pune Airport cab service with timely pickups and drops, helping you reach the airport without any delay or stress."
  },
  {
    WhyChooseheading: "24/7 Pune Airport Cab Availability",
    WhyChoosedescription: "Our Pune Airport cab service operates 24/7, making it easy to book rides for early morning flights, late-night arrivals, and emergency travel."
  },
  {
    WhyChooseheading: "Affordable & Transparent Pricing",
    WhyChoosedescription: "We offer budget-friendly Pune Airport cab services with clear pricing. Customers receive full fare details with no hidden charges."
  },
  {
    WhyChooseheading: "Professional & Experienced Drivers",
    WhyChoosedescription: "SRS Cab Service provides trained and professional drivers who are familiar with Pune Airport routes and traffic conditions, ensuring smooth travel."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All our airport cabs are well-maintained, air-conditioned, and regularly sanitized to provide a comfortable travel experience."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for individual, family, or group airport travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, and all areas including Hinjewadi, Wakad, Baner, Kharadi, Hadapsar, and Viman Nagar."
  },
  {
    WhyChooseheading: "Trusted Pune Airport Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune Airport cab bookings due to reliable service, punctual drivers, and comfortable travel experience."
  }
]
}

const faqData = [
  { question: "Do you provide Pune Airport cab service?", answer: "Yes, SRS Cab Service offers reliable cab services for Pune Airport pickup and drop." },
  { question: "Is Pune Airport cab service available 24 hours?", answer: "Yes, our airport cab service operates 24/7 for all travel needs." },
  { question: "Do you provide airport pickup and drop both?", answer: "Yes, we provide both pickup and drop services to and from Pune Airport." },
  { question: "Which areas do you cover for airport pickup?", answer: "We cover all major areas including Hinjewadi, Wakad, Baner, Aundh, Kharadi, Hadapsar, and Viman Nagar." },
  { question: "Which vehicles are available for airport transfer?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Are airport cabs available for early morning flights?", answer: "Yes, our service is available 24/7 including early morning and late-night bookings." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all our airport cabs are fully air-conditioned." },
  { question: "Can I book Pune Airport cab online?", answer: "Yes, you can easily book airport cabs online or via phone." },
  { question: "Are drivers professional?", answer: "Yes, all our drivers are experienced and trained for airport travel." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rakesh Patil",
    feedback:
      "Booked SRS Cab Service for Pune Airport drop. On-time pickup and smooth ride. Highly recommended.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Neha Sharma",
    feedback:
      "Very reliable Pune Airport cab service. Clean car and professional driver made the journey comfortable.",
    rating: 5
  }
];
































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Airport Cabs | SRS Cab",
  "description": "SRS Cab provides Pune airport cab services including one-way and round trips, airport taxi transfers, car rentals with driver, and online taxi booking. Travel safely and comfortably from Pune Airport to Mumbai, Shirdi, or other destinations with affordable fares and 24x7 service.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};







  return (
    <div>
      
<Helmet>
  <title>Pune Airport Cabs | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book Pune airport cabs with SRS Cab. One-way, round trips, taxi transfers, car rentals with driver, and online booking from Pune Airport to Mumbai, Shirdi, and more. Safe, comfortable rides with 24x7 service and affordable fares." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/23.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Puneairportcabs;